<div class="mat-search-query-builder new-query-builder" *transloco="let translate">
    <query-builder
        [isTaskInitiateProcess]="isTaskInitiateProcess"
        [(ngModel)]="query"
        [config]="config"
        [allowRuleset]="allowRuleset"
        [allowCollapse]="allowCollapse"
        [operatorMap]="customOperatorsMap"
        [parentTouchedCallback]="onParentChange"
        [parentChangeCallback]="onParentChange"
        [emptyMessage]="translate('A ruleset cannot be empty. Please add a rule or remove it all together.')">
        <ng-container
            *queryButtonGroup="let ruleset; let addRule = addRule; let addRuleSet = addRuleSet; let removeRuleSet = removeRuleSet">
            <material-button
                [classList]="['!w-auto']"
                [hidden]="disabled"
                *ngIf="isAddRuleVisible"
                class="queryButton addRule"
                [color]="'primary'"
                [text]="translate('Add New Rule')"
                (buttonClicked)="addRule(); openPanel()"></material-button>
            <material-button
                [classList]="['!w-auto']"
                [hidden]="disabled"
                *ngIf="addRuleSet"
                class="queryButton addRuleSet"
                [color]="'primary'"
                [text]="translate('Add New Rules Block')"
                (buttonClicked)="addRuleSet(); openPanel()"></material-button>
            <material-button
                [classList]="['!w-auto', '!px-[10px]', '!py-[17px]', '!rounded-[3px]']"
                [hidden]="disabled"
                *ngIf="removeRuleSet"
                class="queryButton removeRuleSet"
                buttonType="mini-fab"
                size="small"
                prefixIconType="material"
                prefixIcon="remove"
                [color]="'danger'"
                [titleText]="translate('Remove')"
                (buttonClicked)="removeRuleSet()"></material-button>
        </ng-container>
        <ng-container *queryArrowIcon>
            <mat-icon ngClass="mat-arrow-icon" [hidden]="true">chevron_right</mat-icon>
        </ng-container>
        <ng-container *queryRemoveButton="let rule; let removeRule = removeRule">
            <material-button
                [hidden]="disabled"
                class="queryButton removeRule"
                [color]="'danger'"
                buttonType="mini-fab"
                size="small"
                [titleText]="translate('Remove')"
                prefixIconType="material"
                prefixIcon="remove"
                (buttonClicked)="removeRule(rule)"></material-button>
        </ng-container>
        <ng-container *querySwitchGroup="let ruleset; let onChange = onChange">
            <material-radio-group
                *ngIf="ruleset"
                [radioOptions]="[
                    { displayName: 'AND', value: 'and' },
                    { displayName: 'OR', value: 'or' }
                ]"
                [selectedValue]="ruleset.condition"
                (selectionChanged)="onChange($event)"
                [disabled]="disabled"
                [radioGroupClassList]="['qbCondition']"
                [radioButtonClassList]="['p-[10px]', 'inline-block', 'searchType']"></material-radio-group>
        </ng-container>
        <ng-container *queryEntity="let rule; let entities = entities; let onChange = onChange">
            <mat-form-field appearance="outline" appRemoveAriaOwns>
                <mat-select
                    [placeholder]="translate('Please Select One')"
                    [(ngModel)]="rule.entity"
                    (ngModelChange)="onChange($event, rule)">
                    <mat-option
                        stop-propagation
                        *ngFor="let entity of entities; trackBy: trackByEntityMethod"
                        [value]="entity.value"
                        [title]="entity.name">
                        <span [textContent]="entity.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryField="let rule; let fields = fields; let onChange = onChange; let getFields = getFields">
            <mat-form-field appearance="outline" appRemoveAriaOwns>
                <mat-label *transloco="let translate">{{ translate('Please Select One') }}</mat-label>
                <mat-select
                    [disabled]="disabled"
                    [(ngModel)]="rule.field"
                    (ngModelChange)="onChange($event, rule)"
                    (closed)="searchField = ''">
                    <mat-form-field class="customSearchFilter w-100">
                        <input
                            matInput
                            type="text"
                            [placeholder]="translate('Search Fields')"
                            [(ngModel)]="searchField"
                            (click)="$event.stopPropagation()" />
                        <material-button
                            matSuffix
                            *ngIf="searchField"
                            buttonType="icon"
                            size="medium"
                            [titleText]="translate('Clear Search')"
                            prefixIconType="material"
                            [prefixIcon]="searchField ? 'clear' : 'search'"
                            (buttonClicked)="searchField = ''"></material-button>
                    </mat-form-field>
                    <mat-option
                        stop-propagation
                        *ngFor="
                            let field of getFields(rule.entity) | FilterPipe : 'name' : searchField : undefined : undefined;
                            trackBy: trackByFieldMethod
                        "
                        [value]="field.value"
                        [title]="field.name">
                        <span [textContent]="field.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
            <mat-form-field appearance="outline" class="qbOperator !w-[120px]" appRemoveAriaOwns>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.operator" (ngModelChange)="onOperatorChange($event, rule)">
                    <mat-option
                        stop-propagation
                        *ngFor="let value of operators; trackBy: trackByOperatorsMethod"
                        [value]="value"
                        [title]="translate(value)">
                        <span [textContent]="translate(value)"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; let options = options; type: 'category'; let onChange = onChange">
            <mat-form-field
                class="ruleValueField"
                appearance="outline"
                *ngIf="!isInstanceField(rule) && isTaskInitiateProcess && rule.operator === 'IN'"
                appRemoveAriaOwns>
                <mat-label [textContent]="translate('Select trigger app')"></mat-label>
                <mat-select [disabled]="disabled" (selectionChange)="onAppChange($event, rule)" [ngModel]="getAppId(rule)">
                    <mat-option *ngFor="let opt of options; trackBy: trackByOptionMethod" [value]="opt.value" [title]="opt.name">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field
                class="ruleValueField"
                appearance="outline"
                *ngIf="!isInstanceField(rule) && isTaskInitiateProcess && rule.operator === 'IN' && getAppId(rule)"
                appRemoveAriaOwns>
                <mat-label [textContent]="translate('Select business key(s)...')"></mat-label>
                <mat-select
                    #businessKeySelect
                    [disabled]="disabled"
                    (selectionChange)="onBusinessKeysChange($event, rule, businessKeySelect)"
                    [ngModel]="getBusinessKeys(rule)"
                    multiple>
                    <mat-option
                        *ngFor="let opt of appVsBusinesskeys?.[getAppId(rule)]; trackBy: trackByOptionMethod"
                        [value]="opt.value"
                        [title]="opt.name">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field
                class="ruleValueField"
                appearance="outline"
                *ngIf="rule.operator !== 'IN'"
                appRemoveAriaOwns>
                <mat-label [textContent]="translate('Select a value')"></mat-label>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.value" (ngModelChange)="onChange()">
                    <mat-option
                        stop-propagation
                        *ngFor="let opt of options; trackBy: trackByOptionMethod"
                        [value]="opt.value"
                        [title]="opt.name">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field
                class="ruleValueField"
                appearance="outline"
                *ngIf="
                    (!isTaskInitiateProcess && rule.operator === 'IN') ||
                    (isTaskInitiateProcess && rule.operator === 'IN' && isInstanceField(rule))
                "
                appRemoveAriaOwns>
                <mat-label [textContent]="translate('Select value(s)...')"></mat-label>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.value" multiple (ngModelChange)="onChange()">
                    <mat-option
                        stop-propagation
                        *ngFor="let opt of options; trackBy: trackByOptionMethod"
                        [value]="opt.value"
                        [title]="opt.name">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; let options = options; type: 'boolean'; let onChange = onChange">
            <mat-form-field class="ruleValueField" appearance="outline" appRemoveAriaOwns>
                <mat-label *transloco="let translate">{{ translate('Please Select One') }}</mat-label>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.value" (ngModelChange)="onChange()">
                    <mat-option
                        stop-propagation
                        *ngFor="let opt of options; trackBy: trackByOptionMethod"
                        [value]="opt.value"
                        [title]="opt.name">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; type: 'date'; let onChange = onChange">
            <material-input-date
                [isSearchField]="true"
                appearance="outline"
                [disabled]="disabled"
                [placeholder]="translate('Select Date')"
                [label]="translate('Select Date')"
                [title]="translate('Select Date')"
                [model]="rule.value"
                [dateFormat]="config.fields?.[rule.field]?.['format'] || 'dd/mm/yyyy'"
                [inputOnlyDisabled]="true"
                (modelChange)="rule.value = $event; onChange()"></material-input-date>
        </ng-container>
        <ng-container *queryInput="let rule; let options = options; type: 'multiselect'; let onChange = onChange">
            <mat-form-field class="ruleValueField" appearance="outline" appRemoveAriaOwns>
                <mat-select
                    [disabled]="disabled"
                    [placeholder]="translate('Please Select One')"
                    [(ngModel)]="rule.value"
                    multiple
                    (ngModelChange)="onChange()">
                    <mat-option stop-propagation *ngFor="let opt of options" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'number'; let onChange = onChange">
            <mat-form-field class="ruleValueField" appearance="outline" *ngIf="rule.operator !== 'IN'">
                <input
                    [disabled]="disabled"
                    matInput
                    [(ngModel)]="rule.value"
                    type="number"
                    [placeholder]="translate('Enter Value')"
                    (ngModelChange)="onChange()" />
            </mat-form-field>
            <mat-form-field class="ruleValueField" appearance="outline" *ngIf="rule.operator === 'IN'">
                <mat-label [hidden]="disabled" [textContent]="translate('Enter value(s)...')"></mat-label>
                <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let tagValue of rule.value" (removed)="removeTag(tagValue, rule)">
                        <span [textContent]="tagValue"></span>
                        <mat-icon [title]="translate('Cancel')" [hidden]="disabled" matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input
                        type="number"
                        [hidden]="disabled"
                        [placeholder]="translate('Enter value(s)...')"
                        [matChipInputFor]="chipList"
                        focused
                        (matChipInputTokenEnd)="addNewTag($event, rule)"
                        [title]="translate('Type and hit Enter key or Comma to add multiple values')"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                        (paste)="onPaste($event, rule)" />
                </mat-chip-grid>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'string'; let onChange = onChange">
            <mat-form-field class="ruleValueField" appearance="outline" *ngIf="rule.operator !== 'IN'">
                <input
                    [disabled]="disabled"
                    matInput
                    [(ngModel)]="rule.value"
                    (ngModelChange)="onChange()"
                    [placeholder]="translate('Enter Value')" />
            </mat-form-field>
            <mat-form-field class="ruleValueField" appearance="outline" *ngIf="rule.operator === 'IN'">
                <mat-label [hidden]="disabled" [textContent]="translate('Enter value(s)...')"></mat-label>
                <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let tagValue of rule.value" (removed)="removeTag(tagValue, rule)">
                        <span [textContent]="tagValue"></span>
                        <mat-icon [title]="translate('Cancel')" [hidden]="disabled" matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input
                        [hidden]="disabled"
                        type="text"
                        [placeholder]="translate('Enter value(s)...')"
                        [matChipInputFor]="chipList"
                        focused
                        (matChipInputTokenEnd)="addNewTag($event, rule)"
                        [title]="translate('Type and hit Enter key or Comma to add multiple values')"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                        (paste)="onPaste($event, rule)" />
                </mat-chip-grid>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'textarea'; let onChange = onChange">
            <mat-form-field class="ruleValueField" appearance="outline">
                <textarea
                    [disabled]="disabled"
                    [placeholder]="translate('Enter input')"
                    matInput
                    [(ngModel)]="rule.value"
                    (ngModelChange)="onChange()"></textarea>
            </mat-form-field>
        </ng-container>
    </query-builder>
    <ng-container *ngIf="relationConfigExists">
        <material-button
            [classList]="['!w-auto']"
            [color]="'primary'"
            [hidden]="disabled"
            class="d-flex align-items-center justify-content-end mt-1"
            (buttonClicked)="relationChanged.emit(query)"
            [text]="translate('Apply Relation')"></material-button>
    </ng-container>
</div>
